import spaceContext from 'spaceContext';
import entitySelector from 'entitySelector';
import openHyperlinkDialog from 'app/widgets/WidgetApi/dialogs/openHyperlinkDialog.es6';

/**
 * Should create an object with the same interface as provided by the Contentful JS
 * ui-extensions-sdk `extension` object:
 * https://github.com/contentful/ui-extensions-sdk/blob/master/docs/ui-extensions-sdk-frontend.md
 *
 * Important: Some of the ui-extensions-sdk interface is not yet implemented here
 * and that some of the interface defined here is not part of the ui-extensions-sdk.
 *
 * Note: This deprecates the old `cfWidgetApi` directive.
 *
 * TODO:
 * - Feature parity with ui-extensions-sdk official API.
 * - Move additional functions from here to ui-extensions-sdk as required (e.g. on
 *   customer request or when we want to open-source a widget relying on it).
 *
 * @param {Object} field
 * @param {Object} features
 * @param {string} currentUrl
 * @returns {Object}
 */
export default function buildWidgetApi({ field, features, currentUrl }) {
  const widgetAPI = {
    /**
     * @see https://github.com/contentful/ui-extensions-sdk/blob/master/docs/ui-extensions-sdk-frontend.md#extensionfield
     */
    field,

    /**
     * @see https://github.com/contentful/ui-extensions-sdk/blob/master/docs/ui-extensions-sdk-frontend.md#extensionspace
     */
    space: spaceContext.cma,

    /**
     * @see https://github.com/contentful/ui-extensions-sdk/blob/master/docs/ui-extensions-sdk-frontend.md#extensiondialogs
     */
    dialogs: {
      /**
       * TODO: Does currently not behave as specified by the ui-extensions-sdk as it
       * configures the selector according to the current field.
       *
       * @see https://github.com/contentful/ui-extensions-sdk/blob/master/docs/ui-extensions-sdk-frontend.md#dialogsselectsingleentryoptions
       */
      selectSingleEntry: () => entitySelector.openFromField(field),
      /**
       * TODO: Add to ui-extensions-sdk when open sourcing the StructuredText widget.
       *
       * @see ./createHyperlinkDialog
       */
      createHyperlink: ({ showTextInput, value }) => {
        return openHyperlinkDialog({ showTextInput, value, widgetAPI });
      }
    },

    /**
     * TODO: Add to ui-extensions-sdk when open sourcing the StructuredText widget.
     */
    currentUrl,

    /**
     * TODO: Add to ui-extensions-sdk when open sourcing the StructuredText widget.
     */
    features

    // TODO: .entry
    // TODO: .locales
    // TODO: .user
    // TODO: .window
  };
  return widgetAPI;
}



// WEBPACK FOOTER //
// ./src/javascripts/app/widgets/WidgetApi/buildWidgetApi.es6.js